import { WidgetInfoService, type WidgetInfoServiceRequest, RTKUtils } from '@sevenrooms/api'
import { initializeFormState } from '../reducers/reservationFormSlice'
import { baseReservationWidgetApi } from './BaseReservationWidgetApi'

export const diningWidgetInfoApi = baseReservationWidgetApi.injectEndpoints({
  endpoints: builder => ({
    getWidgetInfo: builder.query<Awaited<ReturnType<typeof WidgetInfoService.getInfo>>, WidgetInfoServiceRequest>({
      queryFn: RTKUtils.rtkQuery(WidgetInfoService.getInfo),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data: response } = await queryFulfilled
          const { widgetSettings, venueInfo, clientInfo } = response
          dispatch(initializeFormState({ venueInfo, widgetSettings, clientInfo }))
        } catch {
          // Do nothing, if this api fails we get directed to the error page,
          // meaning reservations form state is inconsequential
        }
      },
    }),
  }),
})

export const { useGetWidgetInfoQuery } = diningWidgetInfoApi
